import { useRef, useState } from 'react';

export type FeedbackSeverity = 'success' | 'warning' | 'failure';

export type Feedback = {
    id: number;
    severity: FeedbackSeverity;
    text: string;
};

type UseFeedbackSnackbarResult = {
    feedbackEntries: Feedback[];
    showSuccess: (text: string) => void;
    showWarning: (text: string) => void;
    showFailure: (text: string) => void;
    dismissFeedback: (id: number) => void;
};

export function useFeedbackSnackbar(): UseFeedbackSnackbarResult {
    const [feedbackEntries, setFeedbackEntries] = useState<Feedback[]>([]);
    const nextFeedbackId = useRef(0);

    const show = (severity: FeedbackSeverity) => (text: string): void => {
        const id = nextFeedbackId.current;
        nextFeedbackId.current += 1;
        setFeedbackEntries((entries) => [...entries, { id, severity, text }]);
    };

    const dismissFeedback = (id: number): void => {
        setFeedbackEntries((entries) => entries.filter((entry) => entry.id !== id));
    };

    return {
        feedbackEntries,
        showSuccess: show('success'),
        showWarning: show('warning'),
        showFailure: show('failure'),
        dismissFeedback
    };
}
